import React from 'react';
import { HeroSection } from './HeroSection';
import { MirrorSection } from './MirrorSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { TimelineSection } from './TimelineSection';
import { OfferSection } from './OfferSection';
import { FooterSection } from './FooterSection';
export function SalesPage() {
  return <main className="min-h-screen bg-cream font-body text-text-dark selection:bg-gold-light selection:text-text-dark" data-id="element-94">
      <HeroSection data-id="element-95" />
      <MirrorSection data-id="element-96" />
      <ProblemSection data-id="element-97" />
      <SolutionSection data-id="element-98" />
      <TimelineSection data-id="element-99" />
      <OfferSection data-id="element-100" />
      <FooterSection data-id="element-101" />
    </main>;
}